import DeleteConfirmationModal from '@/client/components/admin/shared/overlay/confirmation-modals/DeleteConfirmationModal';
import { useArchiveExpert } from '../hooks/useArchiveExpert';
import { useExpertsStore } from '../expertsStore';
import { useGetPublicImage } from '@/client/services/hooks/media/useGetPublicImage';
import { useTranslation } from 'react-i18next';

export default function ArchiveExpertModal() {
  const { t } = useTranslation();
  const { getPublicImage } = useGetPublicImage();
  const { selectedExpertId, archiveModalIsOpen, setSelectedExpertId, setArchiveModalIsOpen } =
    useExpertsStore();

  const { archiveExpert } = useArchiveExpert();
  const { status } = archiveExpert;

  const onClose = () => {
    setSelectedExpertId('');
    setArchiveModalIsOpen(false);
  };

  return (
    <DeleteConfirmationModal
      isOpen={!!selectedExpertId && archiveModalIsOpen}
      onClose={onClose}
      imageSrc={getPublicImage('continu/app-images/Delete-3--Streamline-Brooklyn.svg')}
      title={t('admin.aiAgent.experts.archiveModal.title')}
      descriptionOne={t('admin.aiAgent.experts.archiveModal.descriptionOne')}
      submitButtonOptions={{
        label: t('admin.aiAgent.experts.archiveModal.submitButtonLabel'),
        isLoading: status === 'loading',
        onClick: () => {
          archiveExpert.mutateAsync(selectedExpertId).then(() => onClose());
        },
      }}
    />
  );
}
